import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { callApi } from '@local_modules/generic/fetch.js'

export async function showEntityRecordsCount (accountingOrganisationId) {
  console.log('showEntityRecordsCount show()', accountingOrganisationId)

  const apiResponse = await getCountEntityRecords(accountingOrganisationId)
  console.log('apiResponse', apiResponse)

  const htmlStringElements = []

  Object.keys(apiResponse).forEach(function (oneKey) {
    htmlStringElements.push(`<b>${oneKey}</b>: ${apiResponse[oneKey]}`)
  })

  setElementHtml('postgresDataCounts', htmlStringElements.join('<br>'))
}

export async function getCountEntityRecords (accountingOrganisationId) {
  const url = '/api/data-review/count-entity-records/:accountingOrganisationId'
  const results = await callApi(url, {
    accountingOrganisationId
  })
  return results
}
